export interface ProductContextState {
  context: string | null;
}

export const initialState: ProductContextState = {
  context: null
};
